import {createSvgIcon} from '../create-svg-icon';

export const FeedbackIcon = createSvgIcon(
  <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17l-.59.59-.58.58V4h16v12zm-9-4h2v2h-2zm0-6h2v4h-2z" />
, 'FeedbackOutlined');
